module.exports = __webpack_public_path__ + "assets/img/clerk_img03.fa931422.png";